import { Box } from '@bpba/ui-components';
import { Filtro } from './Filtro';
import { OptionData } from '../../model/OptionData';
import { NumberFormat } from '../../config/NumberFormat';
import { FiltroRubro } from './FiltroRubro';
import { FILTROS_PUNTOS_LIMITE } from '../../constants/data';

type FiltrosProps = {
  setPuntosDesde(n: number): void;
  setPuntosHasta(n: number): void;
  setOrdenPor(s: string): void;
  showFiltroRubro?: boolean;
};
export const Filtros = (props: FiltrosProps) => {
  const puntosLimite = FILTROS_PUNTOS_LIMITE;
  const opcionesPuntos = puntosLimite.map((number, index) =>
    index === 0
      ? new OptionData(
          index.toString(), //value
          'Menos de ' + NumberFormat.formatNumber(number), //label
          'Menos de ' + NumberFormat.formatNumber(number) + ' puntos.' //aria-label
        )
      : new OptionData(
          index.toString(), //value
          NumberFormat.formatNumber(puntosLimite[index - 1]) + ' - ' + NumberFormat.formatNumber(number), //label
          'Desde ' + NumberFormat.formatNumber(puntosLimite[index - 1]) + ' hasta ' + NumberFormat.formatNumber(number) + ' puntos.' //aria-label
        )
  );
  opcionesPuntos.push(
    new OptionData(
      puntosLimite.length.toString(),
      'Más de ' + NumberFormat.formatNumber(puntosLimite[puntosLimite.length - 1]),
      'Más de ' + NumberFormat.formatNumber(puntosLimite[puntosLimite.length - 1]) + ' puntos.' //aria-label
    )
  );

  const opcionesOrdenarPor = [new OptionData('asc', 'Puntos de menor a mayor'), new OptionData('desc', 'Puntos de mayor a menor')];

  const filtrarPorPuntos = (value: string): void => {
    let desde = 0;
    let hasta = Number.MAX_VALUE;
    const v = parseInt(value);
    if (v === 0) {
      hasta = puntosLimite[0];
    } else if (v === puntosLimite.length) {
      desde = puntosLimite[v - 1];
    } else {
      desde = puntosLimite[v - 1];
      hasta = puntosLimite[v];
    }
    props.setPuntosDesde(desde);
    props.setPuntosHasta(hasta);
  };
  const ordenarPor = (value: string): void => {
    props.setOrdenPor(value);
  };

  return (
    <Box display={'flex'} flexDirection={'row'} flexWrap={['wrap', 'nowrap']} justifyContent={'flex-end'} margin={'0 0 0 auto'} mb={'24px'}>
      {props.showFiltroRubro && <FiltroRubro />}
      <Filtro
        nombre={'Filtrar por cantidad de puntos'}
        margin={['0px 0px 20px 0px', '0px 16px 0px 0px']}
        width={['100%', '50%']}
        maxWidth={['null', '240px']}
        opciones={opcionesPuntos}
        onChange={filtrarPorPuntos}
      />
      <Filtro
        nombre={'Ordenar por'}
        width={['100%', '50%']}
        maxWidth={['null', '240px']}
        opciones={opcionesOrdenarPor}
        onChange={ordenarPor}
      />
    </Box>
  );
};
